import { useTheme } from '@emotion/react';

export default useTheme;
